import React from 'react';

import {Helmet} from 'views/module';

import NewClientScene from 'views/scenes/client/new/NewClient';

const ClientNew = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: New Client</title>
      </Helmet>
      <NewClientScene
      />
    </>
  );
};

export default ClientNew;
